export default class ServicesPresentationXS{ 
  servicesPresentation;
  items;
  constructor(servicesPresentation) {
    this.servicesPresentation = servicesPresentation;
    this.items = this.servicesPresentation.getElementsByClassName('services-presentation-xs-item');
    this.setItemsBreakpoint();
    this.bindListeners();
  }
  

  bindListeners = () => { 
    document.addEventListener('scroll', this._scroll.bind(this));
  }

  setItemsBreakpoint() { 
    for (let item of this.items) { 
      item.breakpoint = item.offsetTop + (item.clientHeight * 75 / 100);
    }
  }

  checkActive(scrollPosition) { 
    for (let i = 0; i < this.items.length; i++) { 
      if (scrollPosition < this.items[i].breakpoint) {
        this.setActive(i);
        return;
      }
    }
    this.setActive(this.items.length - 1);
  }

  setActive(index) { 
    if (!this.items[index].classList.contains('active')) { 
      let activeEl = this.servicesPresentation.querySelector('.services-presentation-xs-item.active');
      activeEl.classList.remove('active');
      this.items[index].classList.add('active');
    }
  }

  _scroll() { 
    let scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    this.checkActive(scrollPosition);
  }

}


// WEBPACK FOOTER //
// ./ui/assets/js/ServicesPresentation/ServicesPresentationXS.js